import { decamelizeKeys } from 'humps';

import {
  Education,
  EducationBot,
  EducationBotFeedback,
  EducationBotHistory,
} from '../types/Education';

import { baseApi } from './baseApi';

type EducationBotHistoryParams = {
  chatId: string;
  page?: number;
};

export const educationApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['Education'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getEducation: builder.query<Education[], number | undefined>({
        query: (id: number | undefined) => ({
          url: 'api/v6/careplan/education',
          params: id ? { procedure_id: id } : {},
        }),
        providesTags: (_result, _error, arg) =>
          arg ? [{ type: 'Education', id: arg }] : ['Education'],
      }),
      askEducationBot: builder.mutation<
        EducationBot,
        { chatId: string; query: string }
      >({
        query: (params) => {
          return {
            url: 'api/v6/ask_seamless/query',
            method: 'POST',
            body: decamelizeKeys(params),
          };
        },
      }),
      sendEducationBotFeedback: builder.mutation<
        EducationBotFeedback,
        { id: string; helpful: boolean; comment?: string }
      >({
        query: (params) => {
          return {
            url: 'api/v6/ask_seamless/feedback',
            method: 'PATCH',
            body: decamelizeKeys(params),
          };
        },
      }),
      getEducationBotHistory: builder.query<
        EducationBotHistory,
        EducationBotHistoryParams
      >({
        query: (params) => ({
          url: 'api/v6/ask_seamless/history',
          params: decamelizeKeys(params),
        }),
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetEducationQuery,
  useLazyGetEducationQuery,
  useAskEducationBotMutation,
  useSendEducationBotFeedbackMutation,
  useGetEducationBotHistoryQuery,
  useLazyGetEducationBotHistoryQuery,
} = educationApi;
